export type TOverSampleType = '2x' | '4x' | 'none';
